import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Skeleton,
} from 'apps/shared/scripts/components';

import messages from '../CardPostForm/messages.json';

const CardPostFormLoader = () => {
  return (
    <>
      <ModalHeader onDismiss={() => {}} title={messages.editPostTitle} />
      <ModalBody>
        <ModalSection>
          <div style={{ height: '430px' }}>
            <Skeleton borderRadius={100} height={10} count={2} offset />
          </div>
        </ModalSection>
      </ModalBody>
      <ModalFooter
        onCancel={() => {}}
        onSubmit={() => {}}
        primaryCtaLabel={messages.editPostCtaLabel}
      />
    </>
  );
};

CardPostFormLoader.displayName = 'CardPostFormLoader';

export default CardPostFormLoader;
